<template>
  <hr class="hidden lg:block lg:my-2 border-t border-gray-100 dark:border-gray-700">
</template>
